(function(){
  // Quick add to bag (opens Dawn cart drawer when present)
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-aprl-add]');
    if(!btn || btn.disabled) return;
    e.preventDefault();
    var drawer = document.querySelector('cart-drawer');
    btn.classList.add('is-loading');
    var body = { id: Number(btn.dataset.aprlAdd), quantity: 1 };
    if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify(body)
    }).then(function(r){ return r.json(); }).then(function(state){
      btn.classList.remove('is-loading');
      if (state.status) { alertless(state.description || state.message); return; }
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.classList.remove('is-empty');
        drawer.renderContents(state);
      } else { window.location.href = '/cart'; }
    }).catch(function(){ btn.classList.remove('is-loading'); window.location.href = '/cart'; });
  });
  function alertless(msg){ console.warn('APRL add to bag:', msg); }

  // Carousels with dots
  function setupCarousel(root, opts){
    var track = root.querySelector('[data-track]'); if(!track) return;
    var dots = root.querySelectorAll('[data-dot]');
    function pos(){ return opts.toIndex(track); }
    function update(){ var i = pos(); dots.forEach(function(d,k){ d.setAttribute('aria-current', k===i ? 'true':'false'); }); }
    track.addEventListener('scroll', function(){ window.requestAnimationFrame(update); }, {passive:true});
    dots.forEach(function(d){ d.addEventListener('click', function(){ track.scrollTo({left: opts.toLeft(track, Number(d.dataset.dot)), behavior:'smooth'}); }); });
    // mouse drag
    var drag=null, moved=false;
    track.addEventListener('mousedown', function(ev){ drag={x:ev.clientX,l:track.scrollLeft}; moved=false; track.style.scrollSnapType='none'; track.style.cursor='grabbing'; });
    window.addEventListener('mousemove', function(ev){ if(!drag) return; var dx=ev.clientX-drag.x; if(Math.abs(dx)>5){moved=true;} track.scrollLeft=drag.l-dx; });
    window.addEventListener('mouseup', function(){ if(!drag) return; drag=null; track.style.scrollSnapType=''; track.style.cursor=''; var i=pos(); track.scrollTo({left:opts.toLeft(track,i),behavior:'smooth'}); });
    track.addEventListener('click', function(ev){ if(moved){ ev.preventDefault(); moved=false; } }, true);
    if (opts.init) opts.init(track);
    update();
  }
  function init(){
    document.querySelectorAll('[data-aprl-art]').forEach(function(root){
      setupCarousel(root, {
        toIndex: function(t){ return Math.max(0, Math.min(2, Math.round((t.scrollLeft / t.clientWidth - 0.25) / 0.5))); },
        toLeft: function(t,i){ return t.clientWidth * (0.25 + i * 0.5); },
        init: function(t){ t.scrollLeft = t.clientWidth * 0.25; if (window.ResizeObserver) new ResizeObserver(function(){ t.scrollLeft = t.clientWidth * 0.25; }).observe(t); }
      });
    });
    document.querySelectorAll('[data-aprl-editorial]').forEach(function(root){
      setupCarousel(root, {
        toIndex: function(t){ return Math.round(t.scrollLeft / t.clientWidth); },
        toLeft: function(t,i){ return i * t.clientWidth; }
      });
    });
    // Lazy video: attach source when in view, pause when out
    document.querySelectorAll('[data-aprl-video]').forEach(function(v){
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if (en.isIntersecting) { if (!v.getAttribute('src')) { v.src = v.dataset.src; v.load(); } v.play().catch(function(){}); }
          else v.pause();
        });
      }, {threshold:.25}).observe(v);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
(function(){var sel='.aprl-card__media, .card-wrapper';function off(){document.querySelectorAll('.is-touching').forEach(function(el){el.classList.remove('is-touching');});}document.addEventListener('touchstart',function(e){off();var el=e.target.closest&&e.target.closest(sel);if(el)el.classList.add('is-touching');},{passive:true});document.addEventListener('touchend',off,{passive:true});document.addEventListener('touchcancel',off,{passive:true});})();